// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__Vd20J","info":"Note_info__31o2W","note":"Note_note__206MC","actions":"Note_actions__3719q"};